import UserCell from './UserCell';

export default UserCell;
